import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Steps,
  Button,
  message,
  Row,
  Col,
  Select,
  Checkbox,
  Input,
  DatePicker,
  Switch
} from 'antd';
import {
  fetchActiveReportsMetaData,
  fetchBillingMetaData,
  fetchBillingServiceMetaData,
  fetchBillingRuleMetaData,
  postBilling,
  getBilling,
  fetchBillingThreshold,
  postBillingThreshold
} from '../actions/sessionActions';

const { Step } = Steps;
const { Option } = Select;
const steps = [
  {
    title: 'Enterprise',
    content: 'First-content'
  },
  {
    title: 'Threshold',
    content: 'Second-content'
  },
  {
    title: 'Service',
    content: 'third-content'
  },
  {
    title: 'Finish',
    content: 'Last-content'
  }
];

const columns = [
  {
    title: 'Service',
    width: 17
  },
  {
    title: 'Billing Rule',
    width: 10
  },
  {
    title: 'Billing Type',
    width: 13
  },
  {
    title: 'Fixed Price',
    width: 8
  },
  {
    title: 'Pricing Per Unit',
    width: 9
  },
  {
    title: 'Total Pricing',
    width: 9
  },
  {
    title: 'Start Date',
    width: 11
  },
  {
    title: 'End Date',
    width: 11
  },
  {
    title: 'Status',
    width: 8
  }
];

class SetupBilling extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      wizardInput: {
        enterpriseId: null,
        threshold: { count: 0, active: false },
        services: [],
        serviceType: [],
        billingType: []
      },
      formInput: [],
      invalidForm: true,
      rules: []
    };
  }

  componentDidMount = () => {
    this.props.fetchActiveReportsMetaData('enterprise');
    this.props.fetchBillingMetaData();
    this.props.fetchBillingServiceMetaData();
    this.props.fetchBillingRuleMetaData();
  };

  validate() {
    let { invalidForm, formInput } = this.state;
    invalidForm = false;
    for (let index = 0; index < formInput.length; index++) {
      for (const key in formInput[index]) {
        if (
          key === 'pricing' &&
          formInput[index]['billingRule'] === 'FREE' &&
          !formInput[index]['pricing']
        ) {
          continue;
        } else if (
          (!formInput[index][key] || formInput[index][key] === null) &&
          key !== 'fixedPrice' &&
          key !== 'perUnitCost'
        ) {
          invalidForm = true;
        }
      }
    }
    if (formInput.length === 0) {
      invalidForm = true;
    }
    this.setState({ invalidForm });
  }

  handleChange = (key, value) => {
    const { wizardInput } = this.state;
    wizardInput[key] = value;
    this.setState({ wizardInput });
  };

  handleCheckBoxChange = e => {
    const { wizardInput } = this.state;
    const { value, checked } = e.target;
    const idx = wizardInput.serviceType.indexOf(value);
    if (idx > -1 && !checked) {
      wizardInput.serviceType.splice(idx, 1);
    } else {
      wizardInput.serviceType.push(value);
    }
    wizardInput.serviceType = wizardInput.serviceType.sort();
    this.setState({ wizardInput });
  };

  buildFormInput = rules => {
    let { formInput, wizardInput } = this.state;
    wizardInput.serviceType = wizardInput.serviceType.sort();
    for (let h = 0; h < wizardInput.serviceType.length; h++) {
      formInput[h] = {
        serviceType: wizardInput.serviceType[h],
        billingRule: null,
        billingType: null,
        fixedPrice: null,
        serviceStartDate: null,
        serviceEndDate: null,
        pricing: null,
        isActive: true
      };
      for (let i = 0; i < rules.length; i++) {
        if (wizardInput.serviceType[h] === rules[i].service_type) {
          formInput[h] = {
            serviceType: rules[i].service_type,
            billingRule: rules[i].billing_rule,
            billingType: rules[i].billing_type,
            serviceStartDate: rules[i].service_start_date,
            serviceEndDate: rules[i].service_end_date,
            pricing: rules[i].pricing,
            isActive: true
          };
          if (rules[i].per_unit_cost) {
            formInput[h].perUnitCost = rules[i].per_unit_cost;
          }
          if (rules[i].fixed_price) {
            formInput[h].fixedPrice = rules[i].fixed_price;
          }
        }
      }
    }
    this.setState({ formInput });
  };

  billingThreshold = () => {
    let { wizardInput } = this.state;
    this.props.fetchBillingThreshold(wizardInput.enterpriseId).then(res => {
      if (res.result) {
        if (res.meta.status === 200) {
          if (res.result.length > 0) {
            wizardInput.threshold.count = res.result[0].threshold;
            wizardInput.threshold.active = res.result[0].is_active;
          } else {
            wizardInput.threshold.count = 0;
            wizardInput.threshold.active = false;
          }
        } else {
          wizardInput.threshold.count = 0;
          wizardInput.threshold.active = false;
        }
        this.setState({ wizardInput });
      }
    });
  };

  next() {
    let current = this.state.current + 1;
    let { formInput, wizardInput, rules } = this.state;
    if (current === 1) {
      this.props.getBilling(wizardInput.enterpriseId).then(res => {
        if (res.result) {
          wizardInput.serviceType = res.result.map(item => item.service_type);
          this.setState(
            { wizardInput, rules: res.result },
            this.buildFormInput(res.result)
          );
          this.billingThreshold();
        }
      });
    } else if (current === 2) {
      const query = {
        enterpriseThreshold: wizardInput.threshold.count,
        isActive: wizardInput.threshold.active,
        enterpriseId: wizardInput.enterpriseId
      };
      this.props.postBillingThreshold(query).then(res => {
        if (res.meta.status === 200) {
          message.success('Enterprise threshold have been configured');
          this.billingThreshold();
        } else {
          current = current - 1;
          message.error(
            'There is some issue with this service, please contact for customer support.'
          );
        }
        this.setState({ wizardInput, current });
      });
      formInput = [];
      this.props.getBilling(wizardInput.enterpriseId).then(res => {
        if (res.result) {
          wizardInput.serviceType = res.result.map(item => item.service_type);
          this.setState(
            { wizardInput, rules: res.result },
            this.buildFormInput(res.result)
          );
        }
      });
    } else if (current === 3) {
      if (rules.length > 0) {
        this.buildFormInput(rules);
      } else {
        formInput = wizardInput.serviceType.map(serviceType => ({
          serviceType,
          billingRule: null,
          billingType: null,
          serviceStartDate: null,
          serviceEndDate: null,
          pricing: null,
          isActive: true
        }));
      }
    }
    this.setState({ current, formInput }, this.validate());
  }

  skip = () => {
    const current = this.state.current + 1;
    let { wizardInput, formInput } = this.state;
    if (current === 2) {
      formInput = [];
      this.props.getBilling(wizardInput.enterpriseId).then(res => {
        if (res.result) {
          wizardInput.serviceType = res.result.map(item => item.service_type);
          this.setState(
            { wizardInput, rules: res.result },
            this.buildFormInput(res.result)
          );
        }
      });
    }
    this.setState({ current, formInput }, this.validate());
  };

  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
    if (current === 1) {
      this.billingThreshold();
    }
  }

  done = () => {
    const { formInput, wizardInput } = this.state;
    this.props
      .postBilling({
        serviceTypeData: JSON.parse(JSON.stringify(formInput)),
        enterpriseId: wizardInput.enterpriseId
      })
      .then(res => {
        if (res.meta.status === 200) {
          message.success('Processing complete!');
        } else {
          message.error(res.meta.message);
        }
      });
  };

  handleSelctionChange(key, value, idx) {
    let { formInput } = this.state;
    formInput[idx][key] = value;
    if (formInput[idx].billingType === 'Shipment Based') {
      if (!formInput[idx].fixedPrice) {
        formInput[idx]['fixedPrice'] = null;
      }
      if (!formInput[idx].perUnitCost) {
        formInput[idx].perUnitCost = null;
      }
    } else {
      delete formInput[idx]['fixedPrice'];
      delete formInput[idx]['perUnitCost'];
    }
    this.setState({ formInput }, this.validate());
  }

  handleInputChange(e, i) {
    const { formInput } = this.state;
    formInput[i][e.target.name] = Number(e.target.value);
    this.setState({ formInput }, this.validate());
  }

  dateChange(date, dateString, name, i) {
    const { formInput } = this.state;
    formInput[i][name] = dateString;
    this.setState({ formInput }, this.validate());
  }

  toggleEvent = (e, i) => {
    const { formInput } = this.state;
    formInput[i].isActive = e;
  };

  handleThresholdInputChange = e => {
    const { wizardInput } = this.state;
    wizardInput.threshold.count = Number(e.target.value);
    this.setState({ wizardInput });
  };

  toggleThresholdEvent = e => {
    const { wizardInput } = this.state;
    wizardInput.threshold.active = e;
    this.setState({ wizardInput });
  };

  render() {
    const { current, wizardInput, formInput, invalidForm, rules } = this.state;
    const { metadata, billing } = this.props;
    return (
      <div>
        <Steps current={current} size="small">
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="steps-content text-left">
          {current === 0 ? (
            <Row>
              <Col span={24}>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Please select an enterprise"
                  optionFilterProp="children"
                  value={
                    this.state.wizardInput.enterpriseId
                      ? this.state.wizardInput.enterpriseId
                      : undefined
                  }
                  onChange={value => this.handleChange('enterpriseId', value)}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {metadata.enterprise.list.map((enterprise, i) => (
                    <Option key={i} value={enterprise.id}>
                      {enterprise.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          ) : null}
          {current === 1 ? (
            <Fragment>
              <Row className="text-left">
                <Col span={2} className="margin-bottom-10">
                  Threshold
                </Col>
                <Col span={2} className="margin-bottom-10">
                  <Input
                    type="Number"
                    name="threshold"
                    id={1}
                    min={1}
                    value={wizardInput.threshold.count}
                    onChange={e => this.handleThresholdInputChange(e)}
                  />
                </Col>
              </Row>
              <Row className="text-left">
                <Col span={2}>Status</Col>
                <Col span={2}>
                  <Switch
                    defaultChecked={false}
                    checked={wizardInput.threshold.active}
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                    onChange={e => this.toggleThresholdEvent(e)}
                  />
                </Col>
              </Row>
            </Fragment>
          ) : null}
          {/* {current === 2 ? (
            <Row className="margin-bottom-10">
              <Col span={24} className="margin-bottom-10">
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Please select an enterprise"
                  optionFilterProp="children"
                  value={
                    this.state.wizardInput.enterpriseId
                      ? this.state.wizardInput.enterpriseId
                      : undefined
                  }
                  onChange={value => this.handleChange('enterpriseId', value)}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {metadata.enterprise.list.map((enterprise, i) => (
                    <Option key={i} value={enterprise.id}>
                      {enterprise.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          ) : null} */}
          {current === 2 ? (
            <Row>
              {rules.length > 0 ? (
                <Col span={24} className="margin-bottom-10">
                  <table
                    className={`ant-table ant-table-small width-100pt text-left`}
                  >
                    <thead className="ant-table-thead">
                      <tr>
                        {columns.map((item, i) => (
                          <th
                            className="padding-8"
                            key={i}
                            width={`${item.width}%`}
                          >
                            {item.title}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                      {formInput.map((item, i) => (
                        <tr key={i}>
                          <td className="padding-8 text-left">
                            {item.serviceType}
                          </td>
                          <td className="padding-8">{item.billingRule}</td>
                          <td className="padding-8">{item.billingType}</td>
                          <td className="padding-8">{item.fixedPrice}</td>
                          <td className="padding-8">{item.perUnitCost}</td>
                          <td className="padding-8">{item.pricing}</td>
                          <td className="padding-8">{item.serviceStartDate}</td>
                          <td className="padding-8">{item.serviceEndDate}</td>
                          <td className="padding-8">
                            {item.isActive ? 'Yes' : 'No'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              ) : null}
              <Col span={24}>
                {rules.length > 0 ? (
                  <h2 className="text-left margin-top-10">
                    Add new service from below list:
                  </h2>
                ) : null}
                <Row className="text-left">
                  {billing.filter.serviceType.map((item, i) => (
                    <Col key={i} span={6} className="padding-8">
                      <Checkbox
                        value={item.value}
                        checked={
                          wizardInput.serviceType.indexOf(item.value) > -1
                            ? true
                            : false
                        }
                        onChange={this.handleCheckBoxChange}
                      >
                        {item.label}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          ) : null}
          {current === 3 ? (
            <Fragment>
              <table className={`ant-table ant-table-small width-100pt`}>
                <thead className="ant-table-thead">
                  <tr>
                    {columns.map((item, i) => (
                      <th
                        className="padding-8"
                        key={i}
                        width={`${item.width}%`}
                      >
                        {item.title}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="ant-table-tbody">
                  {formInput.map((item, i) => (
                    <tr key={i}>
                      <td className="padding-8 text-left">
                        {item.serviceType}
                      </td>
                      <td className="padding-8">
                        <Select
                          showSearch
                          style={{ width: '100%' }}
                          placeholder="Select"
                          optionFilterProp="children"
                          value={
                            item.billingRule ? item.billingRule : undefined
                          }
                          onChange={value =>
                            this.handleSelctionChange('billingRule', value, i)
                          }
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {billing.filter.ruleType.map((item, i) => (
                            <Option key={i} value={item.value}>
                              {item.label}
                            </Option>
                          ))}
                        </Select>
                      </td>
                      <td className="padding-8">
                        <Select
                          showSearch
                          style={{ width: '100%' }}
                          placeholder="Select"
                          optionFilterProp="children"
                          // value={
                          //   this.state.wizardInput.enterpriseId
                          //     ? this.state.wizardInput.enterpriseId
                          //     : undefined
                          // }
                          value={
                            item.billingType ? item.billingType : undefined
                          }
                          onChange={value =>
                            this.handleSelctionChange('billingType', value, i)
                          }
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {billing.filter.billingType.map((item, i) => (
                            <Option key={i} value={item.value}>
                              {item.label}
                            </Option>
                          ))}
                        </Select>
                      </td>
                      <td className="padding-8">
                        {formInput[i].billingType === 'Shipment Based' ? (
                          <Input
                            type="Number"
                            name="fixedPrice"
                            id={item.fixedPrice}
                            min={1}
                            value={item.fixedPrice}
                            onChange={e => this.handleInputChange(e, i)}
                          />
                        ) : null}
                      </td>
                      <td className="padding-8">
                        {formInput[i].billingType === 'Shipment Based' ? (
                          <Input
                            type="Number"
                            min={1}
                            name="perUnitCost"
                            value={item.perUnitCost}
                            onChange={e => this.handleInputChange(e, i)}
                          />
                        ) : null}
                      </td>
                      <td className="padding-8">
                        <Input
                          type="Number"
                          name="pricing"
                          value={item.pricing}
                          min={1}
                          onChange={e => this.handleInputChange(e, i)}
                          required
                        />
                      </td>
                      <td className="padding-8">
                        <DatePicker
                          defaultValue={
                            item.serviceStartDate
                              ? moment(item.serviceStartDate)
                              : null
                          }
                          name="serviceStartDate"
                          onChange={(value, defaultPickerValue) =>
                            this.dateChange(
                              value,
                              defaultPickerValue,
                              'serviceStartDate',
                              i
                            )
                          }
                        />
                      </td>
                      <td className="padding-8">
                        <DatePicker
                          defaultValue={
                            item.serviceEndDate
                              ? moment(item.serviceEndDate)
                              : null
                          }
                          name="serviceEndDate"
                          onChange={(value, defaultPickerValue) =>
                            this.dateChange(
                              value,
                              defaultPickerValue,
                              'serviceEndDate',
                              i
                            )
                          }
                        />
                      </td>
                      <td className="padding-8">
                        <Switch
                          defaultChecked
                          checkedChildren="Active"
                          unCheckedChildren="Inactive"
                          onChange={e => this.toggleEvent(e, i)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Fragment>
          ) : null}
        </div>
        <div className="steps-action">
          {current === 0 ? (
            <Button
              type="primary"
              onClick={() => this.next()}
              disabled={
                current === 0 && wizardInput.enterpriseId ? false : true
              }
            >
              Next
            </Button>
          ) : null}
          {current === 1 ? (
            <Button
              type="primary"
              onClick={() => this.next()}
              disabled={wizardInput.threshold.count ? false : true}
            >
              Next
            </Button>
          ) : null}
          {current === 2 ? (
            <Button
              type="primary"
              onClick={() => this.next()}
              disabled={wizardInput.serviceType.length < 1 ? true : false}
            >
              Next
            </Button>
          ) : null}
          {current === 3 ? (
            <Button
              type="primary"
              onClick={() => this.done()}
              disabled={invalidForm}
            >
              Done
            </Button>
          ) : null}
          {current === 1 ? (
            <Button style={{ marginLeft: 8 }} onClick={() => this.skip()}>
              Skip
            </Button>
          ) : null}
          {current !== 0 ? (
            <Button style={{ marginLeft: 8 }} onClick={() => this.prev()}>
              Previous
            </Button>
          ) : null}
        </div>
      </div>
    );
  }
}

SetupBilling.propTypes = {
  config: PropTypes.object,
  metadata: PropTypes.object,
  billing: PropTypes.object,
  match: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func,
  fetchBillingMetaData: PropTypes.func,
  fetchBillingServiceMetaData: PropTypes.func,
  fetchBillingRuleMetaData: PropTypes.func,
  postBilling: PropTypes.func,
  fetchBilling: PropTypes.func,
  getBilling: PropTypes.func,
  fetchBillingThreshold: PropTypes.func,
  postBillingThreshold: PropTypes.func
};

SetupBilling.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  billing: state.session.billing
});

const mapDispatchToProps = dispatch => ({
  fetchActiveReportsMetaData: data =>
    dispatch(fetchActiveReportsMetaData(data)),
  fetchBillingMetaData: () => dispatch(fetchBillingMetaData()),
  fetchBillingServiceMetaData: () => dispatch(fetchBillingServiceMetaData()),
  fetchBillingRuleMetaData: () => dispatch(fetchBillingRuleMetaData()),
  postBilling: data => dispatch(postBilling(data)),
  getBilling: enterpriseId => dispatch(getBilling(enterpriseId)),
  fetchBillingThreshold: enterpriseId =>
    dispatch(fetchBillingThreshold(enterpriseId)),
  postBillingThreshold: data => dispatch(postBillingThreshold(data))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SetupBilling)
);
